import { SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalContent from './content';
const CustomFeeConfirmation = _ref => {
  let disabled = _ref.disabled,
    handleModalClose = _ref.handleModalClose,
    handleModalOpen = _ref.handleModalOpen,
    isLoading = _ref.isLoading,
    isOpen = _ref.isOpen,
    submitForm = _ref.submitForm;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const trigger = /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "priority",
    'custom-attribute': '131-custom-fee-confirmation'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('buttons.save')));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleModalClose,
    handleOpen: handleModalOpen,
    isOpen: isOpen,
    noFooter: true,
    noPadding: true,
    title: t('add_new_property_flow.confirmation_fee'),
    trigger: trigger
  }, /*#__PURE__*/React.createElement(ModalContent, {
    disabled: disabled,
    isLoading: isLoading,
    submitForm: submitForm
  }));
};
export default CustomFeeConfirmation;